// removed by extract-text-webpack-plugin
module.exports = {"container":"Image__container___kpHnC","image":"Image__image___2_hpY","imageWrapper":"Image__imageWrapper___xlShR","imageText":"Image__imageText___2Ejl_","limitSize":"Image__limitSize___3PKoM","placeholder":"Image__placeholder___4BtBx"};


//////////////////
// WEBPACK FOOTER
// ./~/nucleus-widgets/lib/Image/Image.less
// module id = ./node_modules/nucleus-widgets/lib/Image/Image.less
// module chunks = 31 41